import { render } from "./buy-card.vue?vue&type=template&id=706f3845"
import script from "./buy-card.vue?vue&type=script&lang=js"
export * from "./buy-card.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__